import React, { useEffect } from 'react'
import "./style.scss"

import Filters from './filters';
import CustomValuesHook from '../../functions/myHooks/CustomValuesHook';
import { GetAdminUsers, GetEntitiesEnum, GetHistoryOfImportantEntities, GetRequestLogOfImportantAPIs } from '../../api/requestAxios/userActivities';
// import GSPTable from 'azm-components'
import GSPTable from '../../shared/GSFTable'
import { DetailsSvg } from '../../shared/SVG/iconSvg';
import Details from './details';
import Columns from './columns';



const Activities = () => {
    const [states, setStates] = CustomValuesHook({
        users: [], entities: [],
        sDate: '', eDate: '', user: '', entity: '', pending: false, dataObject: { data: [], pageSize: 10, pageNumber: 1 }
    })

    const createQuery = () => {
        let query = '?'
        if (states.sDate !== '') {
            query = `${query}startDate=${states.sDate}`
        }
        if (states.eDate !== '') {
            if (query === '?') {
                query = `${query}startDate=${states.eDate}`
            } else {
                query = `${query}&endDate=${states.eDate}`
            }

        }
        if (states.user !== '') {
            if (query === '?') {
                query = `${query}UserId=${states.user}`
            }
        }
        return query === '?' ? '' : query;
    }

    const handleSearch = async (args) => {
        let query = createQuery()
        let data = { ...states.dataObject }
        data.data = [];
        if (args) {
            data.pageNumber = args.pageNumber
        }
        setStates({ pending: true, dataObject: data })
        if (query !== '' && args === undefined) {
            query = `${query}&pageSize=10&pageNumber=1`
        } else if (query !== '' && args !== undefined) {
            query = `${query}&pageSize=10&pageNumber=${args.pageNumber}`
        } else {
            query = `?pageSize=10&pageNumber=${args ? args.pageNumber : states.dataObject.pageNumber}`

        }
        let response = await GetRequestLogOfImportantAPIs({ query: query });

        response.data.data.forEach((item, idx) => {
            item.rowNumber = enToPersianChar(((response.data.pageNumber - 1) * response.data.pageSize) + idx + 1)
        })

        data = response.data

        setStates({
            pending: false,
            dataObject: data
        });

    }

    useEffect(() => {
        getRequirements();

    }, [])

    useEffect(() => {
        if (states.sDate !== '' || states.eDate !== '' || states.user !== '') {
            handleSearch();
        }
    }, [states.eDate, states.sDate, states.user])

    const getRequirements = async () => {
        const users = await GetAdminUsers();
        const entities = await GetEntitiesEnum();
        setStates({ users: users.data, entities: entities.data })


    }




    return (
        <main className="change-email user-activities">

            <div className="top-margin"></div>
            <div className="user-info-container user-docs-container user-service-container ">

                <Filters
                    states={states}
                    setStates={setStates}
                    search={handleSearch} />

                <div>
                    <Columns setColumns={(cols) => setStates({ columns: cols })} setStates={setStates} />
                    <GSPTable
                        columns={states.columns}
                        hasSorting={false}
                        apiCall={handleSearch}
                        dataList={states.dataObject}
                        hasFiltering={false}
                        isSearchByExternalBtn={false}
                        hasPaging={true}
                        enableScrolling={false}
                        isStepScrolling={false}
                        pageSize={10}
                    />
                </div>

            </div>
            <Details
                show={states.displayDetail}
                handleClose={() => setStates({ displayDetail: false })}
                details={states.details}
            />
        </main >
    )
}

export default Activities


export const enToPersianChar = (str) => {
    var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    var en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

    var temp = str + "";
    for (var i = 0; i < 10; i++) {
        var regex_en = new RegExp(en[i], 'g');
        temp = temp.replace(regex_en, pn[i]);
    }
    return temp
}
